import React, { useState } from 'react'
import {
  Checkbox,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Row,
  Select,
  TimePicker,
} from 'antd'
import { leagueEventStore } from 'state/league/leagueEvent'
import { useWatch } from 'antd/lib/form/Form'
import Location from 'pages/Events/Views/CreateLeague/screens/Step1/InputComps/Location'
import { Address } from 'types/globalTypes'
import VenueModal from 'pages/Events/Views/CreateEvent/Screens/GeneralDetails/GeneralDetailModal/VenueModal'
import { OrganizationVenues } from 'types/organization'
import DivisionSelect from 'pages/Events/League/Modals/ModalContent/Inputs/DivisionSelect'
import TeamInput from './Inputs/TeamInput'
import { LeagueGamePayloadType } from 'types/league/leagueGame'
import moment from 'moment'
import {
  convertMinutesToLocalTime,
  convertTimeToUtcMinutes,
  formValidationOnRequiredFields,
} from 'helper/utility'
import {
  useCreateLeagueGame,
  useUpdateLeagueGame,
} from 'api/league/leagueGames/leagueGames'
import { myStore } from 'state/store'
import { leagueGamesStore } from 'state/league/leageGames'
import { infoMessage } from 'api/global'

const { Option } = Select

interface AddGameFormProps {
  form: FormInstance
}

const AddGameForm: React.FC<AddGameFormProps> = ({ form }) => {
  const { leagueData } = leagueEventStore(store => ({
    leagueData: store.leagueData,
  }))
  const { setAddGameModal, selectedGame, setSelectedGame } = leagueGamesStore(
    store => ({
      setAddGameModal: store.setAddGameModal,
      selectedGame: store.selectedGame,
      setSelectedGame: store.setSelectedGame,
    }),
  )
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [mapData, setMapModalData] = useState<Address | undefined>(
    selectedGame ? selectedGame.location : undefined,
  )
  const [showCheck, setShowCheck] = useState<boolean>(
    selectedGame && selectedGame.isFriendly ? true : false,
  )
  const [venueModalVisible, setVenueModalVisible] = useState<boolean>(false)
  const [venueDataItem, setVenueDataItem] = useState<OrganizationVenues | null>(
    selectedGame ? selectedGame.venue : null,
  )

  const selectedDivision = useWatch('divisionId', form)
  const disabledDate = (current: moment.Moment) => {
    if (!leagueData?.datesOfEvent || leagueData.datesOfEvent.length === 0) {
      return false
    }
    const currentDateStr = current.format('YYYY-MM-DD')
    return !leagueData.datesOfEvent.some(eventDate => {
      const eventDateStr = moment(eventDate).format('YYYY-MM-DD')
      return eventDateStr === currentDateStr
    })
  }

  const setFieldsValue = leagueData => {
    console.log(leagueData)
  }
  const formSchema = {
    date: selectedGame ? moment(selectedGame.date) : null,
    time: selectedGame ? moment(selectedGame.date) : null,
    round: selectedGame ? selectedGame.round : null,
    homeTeamId: selectedGame ? selectedGame.homeTeam._id : null,
    awayTeamId: selectedGame ? selectedGame.awayTeam._id : null,
    divisionId: selectedGame ? selectedGame.divisionId : null,
    courtFieldNumber: selectedGame ? selectedGame.courtFieldNumber : null,
    isFriendly: selectedGame && selectedGame.isFriendly ? true : false,
  }

  const { mutate: createLeagueGame } = useCreateLeagueGame()
  const { mutate: updateLeagueGame } = useUpdateLeagueGame()

  const hanldeFinish = (values: any) => {
    if (
      !formValidationOnRequiredFields(
        values,
        [
          'date',
          'time',
          'divisionId',
          'homeTeamId',
          'awayTeamId',
          'round',
          'courtFieldNumber',
        ],
        {
          date: 'Date is required',
          time: 'Time is required',
          divisionId: 'Division is required',
          homeTeamId: 'Home team is required',
          awayTeamId: 'Away team is required',
          round: 'Round is required',
          courtFieldNumber: 'Court field number is required',
        },
      )
    )
      return

    if (!mapData) {
      return infoMessage('Location is required')
    }
    if (!venueDataItem) {
      return infoMessage('Venue is required')
    }

    const payload: LeagueGamePayloadType = {
      date: values.date
        ? moment
            .utc(
              `${moment(values.date).format('YYYY-MM-DD')} ${moment
                .utc(values.time)
                .format('HH:mm')}`,
            )
            .format()
        : undefined,
      timings: {
        startTime: convertTimeToUtcMinutes(values.time),
        endTime: undefined,
      },
      leagueId: leagueData._id,
      round: values.round,
      divisionId: selectedDivision,
      homeTeamId: values.homeTeamId,
      awayTeamId: values.awayTeamId,
      locationId: mapData._id,
      venueId: venueDataItem._id,
      courtFieldNumber: values.courtFieldNumber,
      isFriendly: values.isFriendly,
    }

    setModalBtnLoader(true)
    if (selectedGame) {
      updateLeagueGame(
        { payload, gameId: selectedGame._id },
        {
          onSuccess: () => {
            setSelectedGame(null)
            setModalBtnLoader(false)
            setAddGameModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    } else {
      createLeagueGame(payload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          setAddGameModal(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      })
    }
  }
  return (
    <>
      <Form
        form={form}
        layout="vertical"
        initialValues={formSchema}
        onFinish={hanldeFinish}
      >
        <Row gutter={20}>
          <Col span={12}>
            <label htmlFor="" className="input-label">
              Date
            </label>
            <Form.Item name="date">
              <DatePicker
                className="w-100 form-control-field"
                placeholder="MM/DD/YYYY"
                disabledDate={disabledDate}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <label htmlFor="" className="input-label">
              Time
            </label>
            <Form.Item name="time">
              <TimePicker
                format={'hh:mm a'}
                className="w-100 form-control-field"
                placeholder="HH:MM AM/PM"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24} className="">
          <Col span={24}>
            <label htmlFor="" className="input-label required-input">
              Select division
            </label>
            <Form.Item colon={false} name="divisionId">
              <DivisionSelect
                form={form}
                data={selectedGame ? selectedGame.divisionId : undefined}
                leagueId={leagueData._id}
              />
            </Form.Item>
          </Col>
        </Row>

        {selectedDivision && (
          <Row gutter={10}>
            <Col>
              <label className="input-label required-input">Home Team</label>
            </Col>
            <Col>
              <Form.Item className="pointer selector-input" name="homeTeamId">
                <TeamInput
                  form={form}
                  data={selectedGame ? selectedGame.homeTeam._id : undefined}
                  leagueId={leagueData._id}
                  divisionId={selectedDivision}
                  fieldId={'homeTeamId'}
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        {selectedDivision && (
          <Row gutter={10}>
            <Col>
              <label className="input-label required-input">Away Team</label>
            </Col>
            <Col>
              <Form.Item className="pointer selector-input" name="awayTeamId">
                <TeamInput
                  form={form}
                  data={selectedGame ? selectedGame.awayTeam._id : undefined}
                  leagueId={leagueData._id}
                  divisionId={selectedDivision}
                  fieldId={'awayTeamId'}
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={20}>
          <Col span={8}>
            <label className="input-label required-input">Rounds</label>
            <Form.Item className="pointer selector-input" name="round">
              <Input
                type="number"
                min={0}
                placeholder="0"
                className="br-12"
                onWheel={e => e.currentTarget.blur()}
              />
            </Form.Item>
          </Col>
          <Col span={16} className="mt-35px">
            <Form.Item name="isFriendly" valuePropName="checked">
              <div className="checkbox-rounded-sm">
                <Checkbox
                  name="checkbox-style"
                  checked={showCheck}
                  onChange={e => setShowCheck(e.target.checked)}
                >
                  <span className="w-500 text-14 mt-5px">
                    Friendly (not counted in standings)
                  </span>
                </Checkbox>
              </div>
            </Form.Item>
          </Col>
        </Row>

        {leagueData.organizationId && (
          <Row>
            <Col span={24}>
              <Location
                selectedOrganization={{ id: leagueData.organizationId }}
                mapData={mapData}
                setMapModalData={setMapModalData}
                form={form}
              />
            </Col>
          </Row>
        )}

        {mapData && (
          <Row className="mt-20px">
            <Col>
              <label className="input-label required-input">Venue</label>
            </Col>
            <Col>
              <div
                className="w-full border-1px radius-10 flex align-center px-12px pointer h-50px"
                onClick={() => setVenueModalVisible(true)}
              >
                {venueDataItem ? (
                  <div className=" w-full flex justify-between align-center">
                    <p className="text-gray">{`${venueDataItem.name}`}</p>
                  </div>
                ) : (
                  <p className="text-gray">Select Venue</p>
                )}
              </div>
            </Col>
          </Row>
        )}

        <Row gutter={20} className="mt-20px">
          <Col>
            <label className="input-label required-input">
              Court / field number
            </label>
            <Form.Item
              className="pointer selector-input"
              name="courtFieldNumber"
            >
              <Input
                type="number"
                min={0}
                placeholder="0"
                className="br-12"
                onWheel={e => e.currentTarget.blur()}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      {venueModalVisible && (
        <VenueModal
          mapData={leagueData.location}
          setVenueModalVisible={setVenueModalVisible}
          setFieldsValue={setFieldsValue}
          organizationId={leagueData?.organizationId}
          setVenueDataItem={setVenueDataItem}
        />
      )}
    </>
  )
}

export default AddGameForm
